import * as actions from '../actions/scheduling'
import { CALENDAR_TABS } from '../constants/scheduling'

export const initialState = {
  calendar: undefined,
  notes: undefined,
  validateInstallResponse: null,
  selectedCalendarOption: CALENDAR_TABS.FULL_AUTOMATION
}

function schedulingReducer(state = initialState, { type, payload } = {}) {
  switch (type) {
    case actions.SET_CALENDAR: {
      const { calendar } = payload

      return {
        ...state,
        calendar: {
          ...calendar,
          refreshedDates: 
          calendar.refreshedDates || state.calendar?.refreshedDates || []
        }
      }
    }

    case actions.UPDATE_SELECTED_CALENDAR_DATE: {
      const { calendarType, selectedDate: selected } = payload

      return {
        ...state,
        calendar: {
          ...state.calendar,
          [calendarType]: {
            ...state.calendar[calendarType],
            selected
          }
        }
      }
    }

    case actions.SET_SCHEDULING_NOTES: {
      const { notes } = payload

      return {
        ...state,
        notes
      }
    }

    case actions.SET_SCHEDULING_ESCALATION: {
      const { field, value } = payload

      return {
        ...state,
        calendar: {
          ...state.calendar,
          [field]: value
        }
      }
    }

    case actions.SET_REFRESHED_DATES: {
      const { refreshedDates } = payload

      return {
        ...state,
        calendar: {
          ...state.calendar,
          refreshedDates
        }
      }
    }

    case actions.SET_VALIDATE_INSTALL_RESPONSE: {
      const { response } = payload
      
      return {
        ...state,
        validateInstallResponse: response
      }
    }

    case actions.SET_CALENDAR_OPTION: {
      const { optionType } = payload
      
      return {
        ...state,
        selectedCalendarOption: optionType
      }
    }

    default: {
      return state
    }
  }
}

export default schedulingReducer
